import React, { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import controllers from "../../controllers/contacts";
import { ToastContainer, toast } from "../../toastifyProxy";
import "react-toastify/dist/ReactToastify.css";
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const override = css`
  display: block;
  margin: 0 auto;
`;

function FormStyle() {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const { register, handleSubmit, reset } = useForm();

  const recaptchaRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  const CloseButton = ({ closeToast }) => {
    return (
      <i
        onClick={() => {
          closeToast();
        }}
        className="las la-times h-12  text-neutral-400"
      ></i>
    );
  };

  useEffect(() => {
    const notifySuccess = () => {
      return toast.success(showMessage.message, {
        position: "top-center",
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };

    const notifyError = () => {
      return toast.error(showMessage.message, {
        position: "top-center",
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };
    showMessage && showMessage.variant === "success"
      ? notifySuccess()
      : notifyError();
  }, [showMessage]);

  const submitContact = (data) => {
    controllers
      .submitContact(data)
      .then((response) => {
        setLoading(false);
        reset();
        setCaptcha("");
        setShowMessage({
          variant: "success",
          message:
            "Merci. Votre message a bien été envoyé. Nous vous répondrons rapidement.",
        });
      })
      .catch((error) => {
        setCaptcha("");
        setShowMessage({
          variant: "error",
          message:
            "Oups, une erreur s'est produits, Veuillez ressayer plus tard.",
          // message: error,
        });
        setLoading(false);
      });
  };

  function onSubmit(data) {
    if (!captcha) {
      setShowMessage({
        variant: "error",
        message: "Veuillez vous assurer d'avoir entré un captcha valide",
      });
      return;
    }
    data.captcha = captcha;
    setLoading(true);
    submitContact(data);
  }

  function onChange(value) {
    setCaptcha(value);
  }

  return (
    <div className="form-wrapper">
      <ToastContainer />
      <form action="" onSubmit={handleSubmit(onSubmit)}>
        <div className="rn-form-group">
          <input
            type="text"
            name="fullname"
            placeholder={isEnglish ? "Your Full Name" : "Votre Nom Complete"}
            required
            {...register("fullname", { required: true }, { maxLength: 150 })}
          />
        </div>

        <div className="rn-form-group">
          <input
            type="email"
            name="email"
            placeholder={isEnglish ? "Email Address" : "Adress Email"}
            required
            {...register("email", { required: true }, { maxLength: 150 })}
          />
        </div>
        <div className="rn-form-group">
          <textarea
            name="message"
            placeholder={isEnglish ? "Write Message" : "Écrire un message"}
            required
            {...register("message", { required: true }, { maxLength: 2000 })}
            rows={8}
          ></textarea>
        </div>

        <div className="rn-form-group">
          {loading ? (
            <BeatLoader
              color="#dd9378"
              loading={loading}
              css={override}
              size={15}
            />
          ) : (
            <>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Ld7EZ8nAAAAAEkIIQFQCn5q7FgBWp7E3H99uOg4"
                onChange={onChange}
                className="grecaptcha-badge"
              />
              <button
                className="btn-default mt-2"
                type="submit"
                value="submit"
                name="submit"
                id="mc-embedded-subscribe"
                style={{ textTransform: "capitalize" }}
              >
                {isEnglish ? "Submit" : "Envoyer"}
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
export default FormStyle;
